var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoudSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3784 0.181581L3.78746 3.63202H1.5C0.671573 3.63202 0 4.30359 0 5.13202V8.76202C0 9.59045 0.671572 10.262 1.5 10.262H3.78746V10.2802V14.4449C3.78746 15.2733 4.45903 15.9449 5.28746 15.9449H6.07603C6.90446 15.9449 7.57603 15.2733 7.57603 14.4449V11.8809L11.4277 13.5082C12.7462 14.0653 14.206 13.0973 14.206 11.6659V2.00231C14.206 0.547736 12.7026 -0.420327 11.3784 0.181581Z",
    fill: "#EF6963"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoudSpeaker);
export default __webpack_public_path__ + "static/media/loud_speaker.ac42112c98c79365ba267e14e14b1d30.svg";
export { ForwardRef as ReactComponent };